// Remove first and last '/' char, if present
var SLASHES_REGEX = /^\/|\/$/g;
export var defaultKeyGenerator = function (_a) {
    var _b = _a.baseURL, baseURL = _b === void 0 ? '' : _b, _c = _a.url, url = _c === void 0 ? '' : _c, method = _a.method, params = _a.params, id = _a.id;
    if (id) {
        return id;
    }
    // Remove trailing slashes
    baseURL = baseURL.replace(SLASHES_REGEX, '');
    url = url.replace(SLASHES_REGEX, '');
    return "".concat(
    // method
    (method === null || method === void 0 ? void 0 : method.toLowerCase()) || 'get', "::").concat(
    // complete url
    baseURL + (baseURL && url ? '/' : '') + url, "::").concat(
    //params
    params ? JSON.stringify(params, Object.keys(params).sort()) : '{}');
};
